<div class="main-container" [hidden]="skeletonPage">
    <ms-ui-manager />
    <ng-container *ngComponentOutlet="printContainerComponent$ | async" />
    @if (useCustomLayout) {
        @if (columnLayout.layout.isLeftVisible) {
            <ng-scrollbar class="column column-left" viewClass="column-view" [disabled]="!useCustomScrollbar">
                <ms-column [location]="column.Left" />
            </ng-scrollbar>
        }
        @if (disableScroll) {
            <ms-main-column class="column-wrapper" />
        } @else {
            <ng-scrollbar #centerColumn class="column column-center" viewClass="column-view" [disabled]="!useCustomScrollbar">
                <ms-main-column class="column-wrapper" />
            </ng-scrollbar>
        }
        @if (columnLayout.layout.isRightVisible) {
            <ng-scrollbar class="column column-right" viewClass="column-view" [disabled]="!useCustomScrollbar">
                <ms-widget-column class="column-wrapper" />
            </ng-scrollbar>
        }
    } @else {
        <ms-main-column class="column-wrapper" />
    }

    @if (!columnLayout.layout.isRightVisible) {
        <ng-container *msComponentProxy="editBetAddPicksContainerMobileComponent" />
    }
    <ng-container *msComponentProxy="betslipReturnsMessageComponent" />

    @if ((showQuickBet$ | async) || (showQuickBetBuilder$ | async)) {
        <ng-container *msComponentProxy="quickBetComponent" />
    }
    @defer (on immediate) {
        <ms-general-tooltip />
    }
</div>

<div class="main-container" [hidden]="!skeletonPage">
    @if (skeletonPage) {
        <ms-skeleton-sports-base [pageName]="skeletonPage" />
    }
</div>
